export default {
  en: {
    copyright:
      'The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    timeR: 'Count down ',
    timeR2: ' before the activity starts ',
    rank: 'Ranking',
    toptitle: 'Zafer Bayramı',
    title: 'Celebration KSA',
    ruleDes:
      'To celebrate KSA National Day, we will be holding events from September 23rd to 30th. During the event, users send the following gifts, and the winner can get rewards',
    nav1: 'Ranking',
    nav2: 'Room',
    nav3: 'Reward',
    rule: 'Rules',
    share: 'Share',
    rulePop:
      '1. All Turkish users can participate;<br/>2. Each time you give an event gift, you will receive the corresponding event gift currency;<br/>3. During the event, you will automatically enter the leaderboard according to the number of gifts given, and the top three will receive event-exclusive headwear, cars, and VIP rewards.<br/>4. The competition will end at 23:59 Saudi time on September 8, 2024;<br/>5. The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    world: 'World',
    country: 'KSA',
    notice:
      'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'days',
    eventGift: 'Event Gift',
    day: 'Day',
    hour: 'Hour',
    min: 'Min',
    sec: 'Sec',
  },
  ar: {
    copyright:
      'The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    timeR: 'العد التنازلي ',
    timeR2: 'قبل بدء النشاط',
    rank: 'التصنيف',
    toptitle: 'Zafer Bayramı',
    title: 'إحتفال السعودية',
    ruleDes:
      'للاحتفال باليوم الوطني للمملكة العربية السعودية ، سنعقد فعاليات من 23 إلى 30 سبتمبر.  خلال الحدث ، يرسل المستخدمون الهدايا التالية ، ويمكن للفائز الحصول على مكافآت',
    nav1: 'التصنيف',
    nav2: 'الغرف',
    nav3: 'المكافآت',
    rule: 'القواعد',
    rulePop:
      '1. يمكن لجميع المستخدمين الأتراك المشاركة.<br/>2. في كل مرة تقدم فيها هدية حدث، ستتلقى عملة الحدث المقابلة.<br/>3. خلال الحدث، ستدخل تلقائيًا في لوحة الصدارة بناءً على عدد الهدايا التي تم تقديمها، وسيحصل الثلاثة الأوائل على إكسسوارات حصرية للحدث، سيارات، ومكافآت VIP.<br/>ستنتهي المسابقة في 8 سبتمبر 2024 في تمام الساعة 11:59 مساءً بتوقيت السعودية.<br/>5. الحق النهائي في تفسير هذا الحدث يعود إلى Yayya، وليس لهذا الحدث أي علاقة بشركة Apple.',
    world: 'العالم',
    country: 'KSA',
    notice:
      'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'أيام',
    eventGift: 'هدية الحدث',
    day: 'Day',
    hour: 'Hour',
    min: 'Min',
    sec: 'Sec',
  },
  tr: {
    copyright:
      "Bu etkinliğin son yorumlama hakkı Yayya'ye ait olup, bu etkinliğin Apple ile hiçbir ilgisi yoktur.",
    timeR: 'Kalan Süre: ',
    timeR2: ' before the activity starts ',
    rank: 'Sıralama',
    toptitle: 'Zafer Bayramı',
    title: 'Kutlama Suudi Arabistan',
    ruleDes:
      "KSA Ulusal Günü'nü kutlamak için 23-30 Eylül tarihleri arasında etkinlikler düzenleyeceğiz. Etkinlik sırasında kullanıcılar aşağıdaki hediyeleri gönderir ve kazanan ödül alabilir",
    nav1: 'Sıralama',
    nav2: 'Oda',
    nav3: 'Ödül',
    rule: 'Kurallar',
    rulePop:
      "1. Yalnızca Türkiye, Azerbaycan ve Özbekistan paneli kullanıcıları katılabilir; <br/>2. Her etkinlik hediyesi gönderildiğinde, ilgili etkinlik hediyesi para birimini alacaksınız;<br/>3. Etkinlik sırasında, gönderilen hediye sayısına göre otomatik olarak skor tablosuna gireceksiniz ve ilk üçe, etkinliğe özel şapkalar, arabalar ve VIP ödülleri verilecek.<br/>4. Yarışma, 8 Eylül 2024 tarihinde Suudi Arabistan saatiyle 23:59'da sona erecektir;<br/>5. Bu etkinliğin son yorumlama hakkı Yayya'ye ait olup, bu etkinliğin Apple ile hiçbir ilgisi yoktur.",
    world: 'Dünya',
    country: 'KSA',
    notice:
      'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'gün',
    eventGift: 'Etkinlik Hediyeleri',
    day: 'Gün',
    hour: 'Saat',
    min: 'Dakika',
    sec: 'Saniye',
  },
  pt: {
    copyright:
      'O direito de interpretação final deste evento pertence à Yayya, e este evento não tem relação com a Apple.',
    timeR: 'Contagem regressiva ',
    timeR2: ' antes do início da atividade ',
    rank: 'Classificação',
    toptitle: 'Zafer Bayramı',
    title: 'Celebração KSA',
    ruleDes:
      'Para celebrar o Dia Nacional da KSA, realizaremos eventos de 23 a 30 de setembro. Durante o evento, os usuários enviam os seguintes presentes, e o vencedor pode receber recompensas',
    nav1: 'Classificação',
    nav2: 'Sala',
    nav3: 'Recompensa',
    rule: 'Regras',
    share: 'Compartilhar',
    rulePop:
      '1. Todos os usuários turcos podem participar;<br/>2. Cada vez que você der um presente do evento, receberá a moeda correspondente do presente do evento;<br/>3. Durante o evento, você entrará automaticamente no placar de acordo com o número de presentes enviados, e os três primeiros receberão chapéus exclusivos do evento, carros e recompensas VIP.<br/>4. A competição terminará às 23:59, horário da Arábia Saudita, no dia 8 de setembro de 2024;<br/>5. O direito de interpretação final deste evento pertence à Yayya, e este evento não tem relação com a Apple.',
    world: 'Mundo',
    country: 'KSA',
    notice:
      'Se o país da sua conta for alterado durante a atividade, sua classificação no troféu será apagada.',
    days: 'dias',
    eventGift: 'Presente do Evento',
    day: 'Dia',
    hour: 'Hora',
    min: 'Min',
    sec: 'Seg',
  },
  id: {
    copyright:
      'Hak interpretasi akhir dari acara ini milik Yayya, dan acara ini tidak ada hubungannya dengan Apple.',
    timeR: 'Hitung mundur ',
    timeR2: ' sebelum acara dimulai ',
    rank: 'Peringkat',
    toptitle: 'Zafer Bayramı',
    title: 'Perayaan KSA',
    ruleDes:
      'Untuk merayakan Hari Nasional KSA, kami akan mengadakan acara dari 23 hingga 30 September. Selama acara ini, pengguna yang mengirim hadiah berikut akan mendapatkan hadiah berdasarkan peringkat mereka.',
    nav1: 'Peringkat',
    nav2: 'Ruang',
    nav3: 'Hadiah',
    rule: 'Aturan',
    share: 'Bagikan',
    rulePop:
      '1. Semua pengguna Turki dapat berpartisipasi;<br/>2. Setiap kali Anda memberikan hadiah acara, Anda akan menerima mata uang hadiah acara yang sesuai;<br/>3. Selama acara, Anda akan secara otomatis masuk ke papan peringkat sesuai dengan jumlah hadiah yang diberikan, dan tiga besar akan menerima hadiah eksklusif seperti penutup kepala, mobil, dan hadiah VIP.<br/>4. Kompetisi ini akan berakhir pada pukul 23:59 waktu Saudi pada 8 September 2024;<br/>5. Hak interpretasi akhir dari acara ini milik Yayya, dan acara ini tidak ada hubungannya dengan Apple.',
    world: 'Dunia',
    country: 'KSA',
    notice: 'Jika negara akun Anda berubah selama acara, peringkat trofi Anda akan dibersihkan.',
    days: 'hari',
    eventGift: 'Hadiah Acara',
    day: 'Hari',
    hour: 'Jam',
    min: 'Menit',
    sec: 'Detik',
  },
  uz: {
    copyright:
      "Ushbu tadbirning yakuniy tushuntirish huquqi Yayya'ga tegishli va ushbu tadbir Apple bilan hech qanday aloqasi yo'q.",
    timeR: 'Hisoblash',
    timeR2: ' tadbir boshlanishidan oldin',
    rank: 'Reyting',
    toptitle: 'Zafer Bayrami',
    title: 'KSA Bayrami',
    ruleDes:
      "KSA Milliy Kuni munosabati bilan biz 23-sentabrdan 30-sentabrgacha tadbirlar o'tkazamiz. Tadbir davomida foydalanuvchilar quyidagi sovg'alarni yuborishadi va g'olib mukofotlar olishadi.",
    nav1: 'Reyting',
    nav2: 'Xona',
    nav3: 'Mukofot',
    rule: 'Qoidalar',
    share: "Bo'lishish",
    rulePop:
      "1. Barcha Turkiya foydalanuvchilari ishtirok etishi mumkin;<br/>2. Har safar tadbir sovg'asi yuborganingizda, siz mos tadbir sovg'asi valyutasini olasiz;<br/>3. Tadbir davomida sovg'alar soniga qarab avtomatik ravishda reytingga kirasiz, va eng yuqori uchta foydalanuvchi tadbirga xos bosh kiyimlar, avtomobillar va VIP mukofotlarni olishadi.<br/>4. Musobaqa 2024-yil 8-sentabr, Saudiya vaqtida 23:59 da tugaydi;<br/>5. Ushbu tadbirning yakuniy tushuntirish huquqi Yayya'ga tegishli va ushbu tadbir Apple bilan hech qanday aloqasi yo'q.",
    world: 'Dunyo',
    country: 'KSA',
    notice:
      "Agar sizning akkauntingizdagi davlat tadbir davomida o'zgarsa, sizning kubok reytingingiz tozalangan bo'ladi.",
    days: 'kun',
    eventGift: "Tadbir Sovg'asi",
    day: 'Kun',
    hour: 'Soat',
    min: 'Daqiqa',
    sec: 'Sekunda',
  },
  ru: {
    copyright:
      'Право окончательной интерпретации этого события принадлежит Yayya, и это событие не имеет отношения к Apple.',
    timeR: 'Обратный отсчет ',
    timeR2: ' до начала мероприятия ',
    rank: 'Рейтинг',
    toptitle: 'Зафер Байра́мы',
    title: 'Празднование KSA',
    ruleDes:
      'В честь Национального дня KSA мы проведем мероприятия с 23 по 30 сентября. В ходе мероприятия пользователи отправляют следующие подарки, а победитель может получить награды.',
    nav1: 'Рейтинг',
    nav2: 'Комната',
    nav3: 'Награда',
    rule: 'Правила',
    share: 'Поделиться',
    rulePop:
      '1. Все турецкие пользователи могут участвовать;<br/>2. Каждый раз, когда вы отправляете подарки мероприятия, вы получаете соответствующую валюту подарков мероприятия;<br/>3. В ходе мероприятия вы автоматически попадете в таблицу лидеров в зависимости от количества отправленных подарков, и первые три получат эксклюзивные головные уборы, автомобили и VIP-награды.<br/>4. Конкурс завершится в 23:59 по времени Саудовской Аравии 8 сентября 2024 года;<br/>5. Право окончательной интерпретации этого события принадлежит Yayya, и это событие не имеет отношения к Apple.',
    world: 'Мир',
    country: 'KSA',
    notice:
      'Если страна вашего аккаунта изменится во время мероприятия, ваш рейтинг кубков будет очищен.',
    days: 'дней',
    eventGift: 'Подарок мероприятия',
    day: 'День',
    hour: 'Час',
    min: 'Минут',
    sec: 'Секунды',
  },
  fa: {
    copyright:
      'حق تفسیر نهایی این رویداد متعلق به Yayya است و این رویداد هیچ ارتباطی با اپل ندارد.',
    timeR: 'شمارش معکوس ',
    timeR2: ' تا شروع فعالیت ',
    rank: 'رتبه بندی',
    toptitle: 'زافر بایرامی',
    title: 'جشن KSA',
    ruleDes:
      'به مناسبت روز ملی KSA، ما رویدادهایی از 23 تا 30 سپتامبر برگزار خواهیم کرد. در طول رویداد، کاربران هدایای زیر را ارسال می‌کنند و برنده می‌تواند جوایزی دریافت کند.',
    nav1: 'رتبه بندی',
    nav2: 'اتاق',
    nav3: 'جایزه',
    rule: 'قوانین',
    share: 'اشتراک گذاری',
    rulePop:
      '1. تمام کاربران ترکیه‌ای می‌توانند شرکت کنند;<br/>2. هر بار که یک هدیه رویداد ارسال می‌کنید، ارز هدیه مربوطه را دریافت خواهید کرد;<br/>3. در طول رویداد، شما به طور خودکار وارد جدول رده‌بندی خواهید شد بر اساس تعداد هدایای ارسالی و سه نفر اول هدیه‌های مخصوص رویداد، خودرو و جوایز VIP دریافت خواهند کرد.<br/>4. رقابت در ساعت 23:59 به وقت عربستان در 8 سپتامبر 2024 به پایان می‌رسد;<br/>5. حق تفسیر نهایی این رویداد متعلق به Yayya است و این رویداد هیچ ارتباطی با اپل ندارد.',
    world: 'جهان',
    country: 'KSA',
    notice: 'اگر کشور حساب شما در حین فعالیت تغییر کند، رتبه‌بندی جوایز شما پاک خواهد شد.',
    days: 'روز',
    eventGift: 'هدیه رویداد',
    day: 'روز',
    hour: 'ساعت',
    min: 'دقیقه',
    sec: 'ثانیه',
  },
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/lang.js